export default [
  {
    path: '/sistema/empresa/importador',
    name: 'importador',
    component: () => import('@/views/importador/Index.vue'),
    meta: {
      pageTitle: 'Importador de Dados',
      resource: 'TAR_IMPORTACAO',
      action: 'read',
      breadcrumb: [
        {
          text: 'Importador',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sistema/empresa/importador/servicos',
    name: 'importador-servicos',
    component: () => import('@/views/importador/ImportarServicos.vue'),
    meta: {
      pageTitle: 'Importar Serviços',
      resource: 'TAR_IMPORTACAO',
      action: 'read',
      breadcrumb: [
        {
          text: 'Importador',
          to: '/sistema/empresa/importador',
        },
        {
          text: 'Importar Serviços',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sistema/empresa/importador/clientes',
    name: 'importador-clientes',
    component: () => import('@/views/importador/ImportarClientes.vue'),
    meta: {
      pageTitle: 'Importar Clientes',
      resource: 'TAR_IMPORTACAO',
      action: 'read',
      breadcrumb: [
        {
          text: 'Importador',
          to: '/sistema/empresa/importador',
        },
        {
          text: 'Importar Clientes',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sistema/empresa/importador/produtos',
    name: 'importador-produtos',
    component: () => import('@/views/importador/ImportarProdutos.vue'),
    meta: {
      pageTitle: 'Importar Produtos',
      resource: 'TAR_IMPORTACAO',
      action: 'read',
      breadcrumb: [
        {
          text: 'Importador',
          to: '/sistema/empresa/importador',
        },
        {
          text: 'Importar Produtos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sistema/empresa/importador/veiculos',
    name: 'importador-veiculos',
    component: () => import('@/views/importador/ImportarVeiculos.vue'),
    meta: {
      pageTitle: 'Importar Veículos',
      resource: 'TAR_IMPORTACAO',
      action: 'read',
      breadcrumb: [
        {
          text: 'Importador',
          to: '/sistema/empresa/importador',
        },
        {
          text: 'Importar Veículos',
          active: true,
        },
      ],
    },
  },
]
